import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { FeatureFlagKeyName, FeatureFlagValue } from '@mobi/settings'

export type FeatureFlagsState = Partial<Record<FeatureFlagKeyName, FeatureFlagValue>>

export interface FeatureState {
  features: FeatureFlagsState
  /** Specifies whether feature flags are based on anonymous or ID   */
  isUserAnonymous: boolean
  isLdInitialized: boolean
}

export const initialState: FeatureState = {
  isUserAnonymous: true,
  features: {},
  isLdInitialized: false,
}

const slice = createSlice({
  name: 'features',
  initialState: initialState,
  reducers: {
    /** overrides all features state with new feature map  */
    setFeatures(
      state,
      action: PayloadAction<{ features: FeatureFlagsState; isUserAnonymous: boolean }>
    ) {
      state.features = action.payload.features
      state.isUserAnonymous = action.payload.isUserAnonymous
      state.isLdInitialized = true
    },
    mergeFeatures(state, action: PayloadAction<Partial<FeatureFlagsState>>) {
      state.features = { ...state.features, ...action.payload }
    },
  },
})

export const { setFeatures, mergeFeatures } = slice.actions

export default persistReducer(
  {
    key: 'features',
    version: 1,
    storage,
    debug: !PRODUCTION,
  },
  slice.reducer
)
